import { segmentAnalytics as analytics } from '@hungryroot/segment';
import {
  ApiV1LikeDislikeEnum as LikeDislike,
  type UserDefinedRating,
} from './api';

interface Params {
  pairingId: number;
  pairingName: string;
  category: 'pairings' | 'products';
  location: 'card' | 'RDP' | 'PDP';
  path: string;
  likedDisliked: UserDefinedRating;
}

export function trackProductSaved(params: Params) {
  const { likedDisliked, location, category, pairingId, path, pairingName } =
    params;
  analytics.track('Product Reviewed', {
    product_id: pairingId,
    product_name: pairingName,
    category,
    location,
    path,
    rating: likedDisliked === LikeDislike.Liked ? 1 : 0,
    source: 'web',
  });
}
